module.exports = __webpack_public_path__ + "img/p-15.bc41b511.png";